var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconZoomOutLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconZoomOut",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M853 1600c-382.293 0-693.333-311.04-693.333-693.333 0-382.294 311.04-693.334 693.333-693.334 382.293 0 693.333 311.04 693.333 693.334C1546.333 1288.96 1235.293 1600 853 1600Zm997.76 228.907-396.373-396.267C1577.587 1291.733 1653 1108.16 1653 906.667c0-441.174-358.827-800-800-800s-800 358.826-800 800c0 441.173 358.827 800 800 800 201.387 0 385.173-75.414 525.973-198.614l396.267 396.374 75.52-75.52ZM479.667 960.053h746.666V853.387H479.667v106.666Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconZoomOutLine.glyphName = 'zoom-out';
IconZoomOutLine.variant = 'Line';
IconZoomOutLine.displayName = 'IconZoomOutLine';
IconZoomOutLine.allowedProps = [...SVGIcon.allowedProps];
export default IconZoomOutLine;
export { IconZoomOutLine };